/* eslint-disable filenames/match-exported */
import { createStore, applyMiddleware, compose } from "redux";
import { watchAuth, watchTokenChange, watchRedirectResult } from "./services/firebase";
//middlwares
import thunk from "redux-thunk";
import MixpanelMiddleware from "redux-mixpanel-middleware";
import { accesstokenSetter } from "./middleware/accesstokenSetter";
import { ErrorReporter } from "./middleware/ErrorReporter";

import sagaMiddleware, { runSaga } from "./middleware/sagasMiddleware";
import rootSaga from "./sagas/client";
import mixpanel from "./services/mixpanel";
import { routerLocationChanged } from "./middleware/locationChange";
import InteractionsTracker from "./middleware/InteractionsTracker";

import { initializeCurrentLocation } from "redux-little-router";
import { getReduxDevtoolsExtensionCompose } from "./util";
import { getRouter } from "./util/Router";
import { getReducers } from "./reducers";
import IS_CLIENT_RENDERED from "./util/isClientRendered";
import { setSSRUserFlag } from "./actions/userActions";

const mixpanelMiddleware = new MixpanelMiddleware(mixpanel);

export const getStore = req =>
  new Promise((resolve, reject) => {
    const { middleware: routesMiddleware, enhancer: routerEnhancer } = getRouter(req);
    const reducer = getReducers(req);
    const composeEnhancers = getReduxDevtoolsExtensionCompose() || compose;

    const enhancer = composeEnhancers(
      routerEnhancer,
      applyMiddleware(
        sagaMiddleware,
        InteractionsTracker,
        thunk,
        mixpanelMiddleware,
        accesstokenSetter,
        routesMiddleware,
        routerLocationChanged,
        ErrorReporter
      )
    );

    if (IS_CLIENT_RENDERED) {
      const preloadedState = window.__PRELOADED_STATE__;
      delete window.__PRELOADED_STATE__;
      const store = createStore(reducer, preloadedState, enhancer);
      const initialLocation = store.getState().router;
      if (initialLocation) {
        store.dispatch(initializeCurrentLocation(initialLocation));
      }
      // Grab the state from a global variable injected into the server-generated HTML

      runSaga(rootSaga, store.dispatch);
      watchAuth(store.dispatch);
      watchTokenChange(store.dispatch);
      watchRedirectResult(store.dispatch);
      resolve(store);
    } else {
      const store = createStore(reducer, enhancer);
      const initialLocation = store.getState().router;
      if (initialLocation) {
        store.dispatch(initializeCurrentLocation(initialLocation));
      }

      const currentRoute = store.getState().router;
      if (currentRoute.pathname !== "/") {
        store.dispatch({ type: "SIGNOUT" });
      }
      
      const serverSaga = currentRoute.result.saga;
      if (!serverSaga) {
        return resolve(store);
      }
      const task = runSaga(serverSaga, currentRoute);
      
      store.dispatch(setSSRUserFlag(true));
      task.done.then(() => resolve(store));
    }
  });

export default getStore;



// WEBPACK FOOTER //
// ./src/store.js